
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.672 5.367c.277.288.354.673.26 1.069.615-.076 1.192.075 1.604.5.816.819.547 2.215-.736 3.26-1.328 1.077-2.83 1.057-3.49.028-.324-.508-.33-1.143-.085-1.726-.448-.01-.825-.182-1.046-.525-.444-.684-.036-1.665.939-2.374.954-.697 2.006-.801 2.554-.232zM8.266 7.16c.206.277.633.282 1.027.007a.363.363 0 00.02-.015c.01-.008.02-.017.031-.023l.027-.02a.215.215 0 00.03-.023c.358-.295.46-.687.239-.945-.224-.266-.663-.243-1.049.045-.394.285-.53.69-.325.974zm3.033.745c-.308-.362-.855-.342-1.321.014-.47.348-.618.891-.338 1.275.295.39.872.404 1.369.009.49-.387.607-.945.29-1.298z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.003 22C6.498 22 2.011 17.523 2 12.02 1.99 6.504 6.468 2.01 11.98 2h.022c5.505 0 9.99 4.477 9.998 9.98.011 5.514-4.466 10.007-9.98 10.02h-.017zm2.692-15.6c.797 1.806.061 4.453-2.541 5.811-3.95 2.097-7.91-.23-7.03-4.117C5.71 5.494 8.4 3.981 10.668 4c1.785.027 3.399.983 4.027 2.4z","fill":"#fff"}})])
          )
        }
      }
    